import React from "react";
import {Link} from "react-router-dom";

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardTitle,
  Form,
  Input,
  Container,
  Row,
  Col
} from "reactstrap";

// core components
import MainNavbar from '../../components/Navbars/MainNavbar';
import LandingPageHeader from "../../components/Headers/LandingPageHeader.js";
import FooterWhite from "../../components/Footers/FooterWhite.js";
import ContactUs from "../../components/Consumer/ContactUs"

import laundryIcon from "../../assets/mylazybones/img/LandingPage/icons/laundry_icon.svg";
import storageIcon from "../../assets/mylazybones/img/LandingPage/icons/storage_icon.svg";
import suppliesIcon from "../../assets/mylazybones/img/LandingPage/icons/supplies_icon.svg";
import giftCardIcon from "../../assets/mylazybones/img/LandingPage/icons/giftcard_icon.svg";



function LandingPage(props) {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("landing-page");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("landing-page");
    };
  });
  return (
    <>
      <MainNavbar {...props} /> 
      <main>
      <LandingPageHeader {...props} />
      <div className="wrapper">
        <div id="lb-services" className="section section-feature cd-section  landing-section pb-0">
          <div className="features-3">
              <Container>
                  <Row>
                    <Col md="6" role="region" aria-labelledby="lb-services-heading">
                      <Row>
                        <Container>
                          <h2 className="title" id="lb-services-heading">Lazybones Services to Make Your Life Easier</h2>
                        </Container>
                      </Row>
                      <Row>
                        <Col md="6">
                          <div className="info info-horizontal">
                            <div className="icon icon-success">
                              <img
                                  style={{width:"35px",height:"35px",objectFit:"contain"}}
                                  src={laundryIcon}
                                  alt="Image of a washing machine icon"
                              />
                            </div>
                            <div className="description">
                              <h3 className="info-title landing-page-info-title">Laundry</h3>
                              <p>
                                Student and residential laundry service, picked up and delivered to your door step.
                              </p>
                              <p>
                               See More:<br/>
                               <Link to="/laundry/how-it-works/student" className="btn-link btn btn-success">Students</Link>
                               <Link to="/laundry/how-it-works/residential" className="btn-link btn btn-success">Residential</Link>
                               <Link to="/laundry/how-it-works/commercial" className="btn-link btn btn-success">Commercial</Link>
                              
                              </p>
                            </div>
                          </div>
                          
                        </Col>
                        <Col md="6">
                          
                          <div className="info info-horizontal">
                            <div className="icon icon-warning">
                              <img
                                  style={{width:"35px",height:"35px",objectFit:"contain"}}
                                  src={storageIcon}
                                  alt="Image of a storage icon"
                              />
                            </div>
                            <div className="description">
                              <h3 className="info-title landing-page-info-title">Storage</h3>
                              <p>
                                You pack it, we store it. Safe, reliable storage with no monthly fees. We also provide convenient shipping services as well.
                              </p>
                              <Link to="/storage/how-it-works/student" className="btn-link btn btn-warning">See more</Link>
                            </div>
                          </div>
                        </Col>
                        <Col md="6">
                          <div className="info info-horizontal">
                            <div className="icon icon-danger">
                              <img
                                  style={{width:"35px",height:"35px",objectFit:"contain"}}
                                  src={suppliesIcon}
                                  alt="Image of a supplies icon"
                              />
                            </div>
                            <div className="description">
                              <h3 className="info-title landing-page-info-title">Supplies</h3>
                              <p>
                                The moving supplies you need, boxes, tape, bubble wrap and more, delivered to your door.
                              </p>
                              <Link to="/supplies/view-catalog" className="btn-link btn btn-danger">See more</Link>
                            </div>
                          </div>
                          
                        </Col>
                        <Col md="6">
                          
                          <div className="info info-horizontal">
                            <div className="icon icon-primary">
                              <img
                                  style={{width:"35px",height:"35px",objectFit:"contain"}}
                                  src={giftCardIcon}
                                  alt="Image of a gift-card icon"
                              />
                            </div>
                            <div className="description">
                              <h3 className="info-title landing-page-info-title">Gift Cards</h3>
                              <p>
                                Give the gift of cleanliness all semester long. 
                              </p>
                              <Link to="/gift-cards/" className="btn-link btn btn-primary">See more</Link>
                            </div>
                          </div>
                        </Col>
                      
                        
                      </Row>
                      
                    </Col>
                    <Col className="ml-auto d-none d-sm-block" md="5">
                      <div className="iphone-container">
                        <img
                          alt="..."
                          src={require("assets/mylazybones/img/LandingPage/laundry-stacked-clothes.jpg")}
                        />
                      </div>
                    </Col>
                  </Row>
              </Container>
          </div>  
        </div>
        <div className="section landing-section pt-0">
            <ContactUs />
        </div>
      </div>
      </main>
      <FooterWhite />
    </>
  );
}

export default LandingPage;
